import React from 'react';
import { bool, func, string, object } from 'prop-types';
import { translate } from '@airasia-common/libraries/i18n/LocaleProvider';
import Wrapper from '../Wrapper';
import Row from '../Container/Row';
import Column from '../Container/Column';
import { BodyText, H3 } from '../Text/Heading';
import { defaultFunc } from '../../utils/props';
import Button from '../Button';
import ResponsiveModal from './ResponsiveModal';

const MAX_MODAL_WIDTH = 600;

const ConfirmModal = ({
  title,
  content,
  isOpen,
  onClose,
  onCancelConfirm,
  modalStyle = {},
  move,
}) => {
  return (
    <ResponsiveModal
      width={[0.8, MAX_MODAL_WIDTH]}
      isOpen={isOpen}
      onClose={onClose}
      modalStyle={{
        top: ['40%', '50%'],
        bottom: 'auto',
        style: {
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.4)',
            zIndex: 101,
          },
          ...modalStyle,
        },
      }}
    >
      <Column m={5}>
        <H3 fontSize={['16px', '20px']} lineHeight={['20px', '26px']}>
          {title}
        </H3>
        <BodyText fontWeight="normal" lineHeight={1.25} mt={3} mb={6}>
          {content}
        </BodyText>
        <Row width={1} justifyContent={move ? 'space-around' : 'flex-end'}>
          <Wrapper mr={move ? '13px' : '22px'}>
            <Button
              secondary
              onClick={onClose}
              style={{
                height: move && '48px',
                width: move && '140px',
                paddingTop: move && '16px',
              }}
              move={move}
              border={move && '#023C40'}
              borderRadius={move && '32px'}
              hovercolor={move && '#E8F2EC'}
            >
              {translate('confirmDialog.cancel')}
            </Button>
          </Wrapper>
          <Wrapper>
            <Button
              secondary={!move}
              onClick={onCancelConfirm}
              style={{
                height: move && '48px',
                width: move && '140px',
                paddingTop: move && '16px',
              }}
              move={move}
              border={move && '#023C40'}
              borderRadius={move && '32px'}
              hovercolor={move && '#12C25A'}
              backgroundColor={move && '#0CE865'}
            >
              {translate('confirmDialog.confirm')}
            </Button>
          </Wrapper>
        </Row>
      </Column>
    </ResponsiveModal>
  );
};

ConfirmModal.propTypes = {
  title: string,
  content: string,
  isOpen: bool,
  onClose: func,
  onCancelConfirm: func.isRequired,
  modalStyle: object,
  move: bool,
};

ConfirmModal.defaultProps = {
  onClose: defaultFunc,
  onCancelConfirm: defaultFunc,
};

export default ConfirmModal;
